'use client';
import { usePathname } from 'next/navigation';

export const GoogleTagManager = () => {
    const pathname = usePathname();

    // Define routes where GTM should NOT be shown (authenticated/dashboard pages)
    // Note: We explicitly ensure /success routes are NOT excluded
    const isExcluded =
        (pathname?.startsWith('/customer-dashboard') ||
        pathname?.startsWith('/freelancer-dashboard') ||
        pathname?.startsWith('/control') ||
        pathname?.startsWith('/(superadmin)') ||
        pathname?.startsWith('/dashboard')) &&
        !pathname?.includes('/success');

    if (isExcluded) return null;

    return (
        <script
            id="gtm-script"
            dangerouslySetInnerHTML={{
                __html: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src="https://ksbttrtk.in.stape.io/2jbksbttrtk.js?"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','u=AhBPMyAvXj8xI0VBPlc9TR1JQFpF');
          `,
            }}
        />
    );
};

export const GoogleTagManagerNoScript = () => {
    const pathname = usePathname();

    const isExcluded =
        (pathname?.startsWith('/customer-dashboard') ||
        pathname?.startsWith('/freelancer-dashboard') ||
        pathname?.startsWith('/control') ||
        pathname?.startsWith('/(superadmin)') ||
        pathname?.startsWith('/dashboard')) &&
        !pathname?.includes('/success');

    if (isExcluded) return null;

    return (
        <noscript>
            <iframe
                src="https://ksbttrtk.in.stape.io/ns.html?id=GTM-TZW75J5N"
                height="0"
                width="0"
                style={{ display: 'none', visibility: 'hidden' }}
            ></iframe>
        </noscript>
    );
};

export default GoogleTagManager;

